// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__c2T+g","modal":"Modal_modal__LIo5R","slide-down":"Modal_slide-down__CDfOD"};